module.exports = __webpack_public_path__ + "img/logo-colorful.2d316bb1.png";